import { createNullableProvideInject } from '@collector/shared-ui'

import { AttributesToResetParticipants } from '../configuration'

export const [
  provideAttributesToResetParticipants,
  injectAttributesToResetParticipants,
] = createNullableProvideInject<AttributesToResetParticipants>(
  'attributesToResetParticipants',
)
